export default "__VITE_ASSET__CqVxq7W1__"